// export this package's api
import Align from './Align';
export default Align;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-align/es/index.js
// module id = 432
// module chunks = 0 1